import { useEffect } from "react";

export function useEmojiPickerDismiss(
  isOpen: boolean,
  onClose: () => void,
  anchorRef: any,
  pickerRef: any,
) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const handlePointerDown = (event: MouseEvent) => {
      const target = event.target as Node;

      if (anchorRef.current?.contains(target)) {
        return;
      }

      if (pickerRef.current?.contains(target)) {
        return;
      }

      onClose();
    };

    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [isOpen, onClose, anchorRef, pickerRef]);
}
